import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { createOctaveBand, updateOctaveBand , removeOctaveBand , getOctaveBands} from '../api/util';
import { RootState } from '../store';


export interface ProjectState {
    octaveModelList?: any[],
    newProjectResponse?:any,
    fetching: boolean,
}

const initialState: ProjectState = {
    octaveModelList: undefined,
    fetching:false

}


export const createOctaveBandModel = createAsyncThunk(
    'bladeModal/createHubBand',
    async (data: any, thunkAPI) => {
        try {
            const response = await createOctaveBand(data); 
            return response.response;
        } catch (error) {
            return error;
        }
    }
);
export const updateOctaveBandModel = createAsyncThunk(
    'bladeModal/updateHubBand',
    async (data: any) => {
        const response = await updateOctaveBand(data);
        console.log("createNewModel",response.response)
        return response.response;
    }
);


export const removeOctaveBandModel = createAsyncThunk(
    'bladeModal/removeHubBand',
    async (data: any) => {
        const response = await removeOctaveBand(data);
        console.log("createNewModel",response.response)
        return response.response;
    }
);

export const getOctaveBandsModels = createAsyncThunk(
    'bladeModal/getHubBandAPI',
    async () => {
        const response = await getOctaveBands();
        console.log("getBladeModels",response.response)
        return response.response;
    }
);


export const OctaveBandSlice = createSlice({
    name: 'octaveBandModel',
    initialState,
    reducers: {
        resetBladeModelStore: (state) => {
            state = initialState;
        }
    }, extraReducers: (builder) => {
        builder
            .addCase(getOctaveBandsModels.pending, (state) => {
                state.fetching = true;
                state.octaveModelList = undefined
            })
            .addCase(getOctaveBandsModels.fulfilled, (state, action) => {
                state.fetching = false;
                state.octaveModelList = action.payload.data;
            })
            .addCase(getOctaveBandsModels.rejected, (state) => {
                state.fetching = false;
            })

            .addCase(updateOctaveBandModel.pending, (state) => {
                state.fetching = true;
                state.octaveModelList = undefined
            })
            .addCase(updateOctaveBandModel.fulfilled, (state, action) => {
                state.fetching = false;
                state.octaveModelList = action.payload.data;
            })
            .addCase(updateOctaveBandModel.rejected, (state) => {
                state.fetching = false;
            })


            .addCase(removeOctaveBandModel.pending, (state) => {
                state.fetching = true;
                state.octaveModelList = undefined
            })
            .addCase(removeOctaveBandModel.fulfilled, (state, action) => {
                state.fetching = false;
                state.octaveModelList = action.payload.data;
            })
            .addCase(removeOctaveBandModel.rejected, (state) => {
                state.fetching = false;
            })

            .addCase(createOctaveBandModel.pending, (state,action) => {
                state.fetching = true;
                state.newProjectResponse = undefined
            })
            .addCase(createOctaveBandModel.fulfilled, (state, action) => {
              
                state.fetching = false;
                state.newProjectResponse = action.payload
            })
            .addCase(createOctaveBandModel.rejected, (state,action) => {
                state.fetching = false;
                state.newProjectResponse = action.error.message ;
            })
    }
})


export const { resetBladeModelStore } = OctaveBandSlice.actions;

export const octaveBandModelList = (state: RootState) => state.octaveBandModel.octaveModelList;
export const newProjectResponse = (state: RootState) => state.octaveBandModel.newProjectResponse;


export default OctaveBandSlice.reducer;